"use client";

import { useQuery } from "@apollo/client";
import { Box, Grid } from "@chakra-ui/react";
import Image from "next/image";
import { FC } from "react";
import YouTube from "react-youtube";
import { GetMembershipBenefitDocument } from "../../../graphql/generated/graphql";
import Dialog from "../../../components/Dialog";
import Markdown from "../../../components/Markdown";
import { useConfig } from "../../../app/ConfigProvider";
import { TileContent, TileWrapper } from "./Tile";

const Benefits: FC = () => {
  const { welcomeVideo: videoId } = useConfig();
  const { data: membershipBenefitsData } = useQuery(
    GetMembershipBenefitDocument,
  );

  const membershipBenefits = membershipBenefitsData?.membershipBenefits ?? [];

  return (
    <div>
      <Box maxWidth={1200}>
        {videoId && (
          <Box overflow="hidden" borderRadius={10}>
            <YouTube videoId={videoId} />
          </Box>
        )}

        <Grid
          templateColumns={{
            base: "repeat(auto-fill, minmax(151px, 1fr))",
            sm: "repeat(auto-fill, minmax(201px, 1fr))",
          }}
          gap={6}
          mt={6}
          fontWeight="bold"
        >
          {membershipBenefits.map(({ title, description, image, width }) => (
            <TileWrapper key={title}>
              <Dialog
                header={title}
                trigger={
                  <TileContent
                    key={title}
                    icon={
                      <Box w={width ? `${width}%` : undefined}>
                        <Image
                          src={image}
                          alt=""
                          width={137}
                          height={171}
                          style={{
                            maxWidth: "100%",
                            height: "auto",
                          }}
                        />
                      </Box>
                    }
                  >
                    {title}
                  </TileContent>
                }
              >
                <Markdown>{description}</Markdown>
              </Dialog>
            </TileWrapper>
          ))}
        </Grid>
      </Box>
    </div>
  );
};

export default Benefits;
